const isValidDate = (dateString: string) => {
  const date = new Date(dateString);
  return !Number.isNaN(date) && date.toString() !== 'Invalid Date';
};

export const getElapsed = (dateTime: string | Date, locale?: string) => {
  if (!isValidDate(dateTime.toLocaleString())) {
    return false;
  }
  const rtf1 = new Intl.RelativeTimeFormat(locale, { style: 'long' });
  const ms = Date.now() - Date.parse(dateTime.toString());

  const sec = ms / 1000;
  const min = ms / 1000 / 60;
  const hr = min / 60;
  const day = hr / 24;
  const week = day / 7;
  const year = week / 52;

  const diffDate = new Date(dateTime);
  const diffMonth = diffDate.getMonth();
  const diffYear = diffDate.getFullYear();
  const curDate = new Date();
  const curMonth = curDate.getMonth();
  const curYear = curDate.getFullYear();

  const yearDiff = (curYear - diffYear) * 12;
  const month = curMonth + yearDiff - diffMonth;

  if (Math.abs(year) >= 1 || Math.abs(month) === 12) {
    const y = Math.round(year);
    return rtf1.format(-y, 'year');
  }
  if (
    (Math.abs(month) > 1 && Math.abs(month) < 12) ||
    Math.abs(Math.round(week)) >= 5
  ) {
    const m = Math.round(month);
    return rtf1.format(-m, 'month');
  }
  if (Math.abs(week) >= 1 && Math.abs(week) < 5) {
    const w = Math.round(week);
    return rtf1.format(-w, 'week');
  }
  if (Math.abs(day) >= 1 && Math.abs(day) < 7) {
    const d = Math.round(day);
    return rtf1.format(-d, 'day');
  }
  if (Math.abs(hr) >= 1 && Math.abs(hr) < 24) {
    const h = Math.round(hr);
    return rtf1.format(-h, 'hour');
  }
  if (Math.abs(min) >= 1 && Math.abs(min) < 60) {
    const m = Math.round(min);
    return rtf1.format(-m, 'minute');
  }

  const s = Math.round(sec);
  return rtf1.format(-s, 'second');
};
